import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationSteps, ApplicationState } from "../../../../../applications/models/applications.models";
import { AuthService } from "../../../../../services/auth.service";
import { DomainValue } from '../../../../../models/domain.model';
import { DomainDefinitionService } from '../../../../../builder/services/domain-definition.service';


@Component({
    selector: 'plat-reviewer',
    templateUrl: './plat-reviewer.component.html',
    styleUrls: ['./plat-reviewer.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class PlatReviewerComponent extends ApplicationSectionBaseComponent implements OnInit, OnDestroy {

    readonly step: ApplicationSteps = ApplicationSteps.Review;

    public locationSources: Observable<DomainValue[]>;

    get preliminaryDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('asDrilledPlatPreliminaryDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get platFinalDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('asDrilledPlatFinalDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }


    get boreholeDeviationSurveyDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('boreholeDeviationSurveyDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }


    get revisedUnitDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('revisedUnitDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }


    get asDrilledFeeDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('asDrilledFeeDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get revisedUnitFeeDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('revisedUnitFeeDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    

    subscription: Subscription = new Subscription();

    get totalDepthDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('totalDepthDate');
        if (ctrl == null) return null;
        return ctrl.value;
    }

    constructor(_auth: AuthService, private domainService: DomainDefinitionService) { super(_auth); }

    ngOnInit() {

        this.locationSources = this.domainService.getValues("SOURCE_LOC").pipe(
            map((data: DomainValue[]) => {                
                data.unshift({
                    Code: "", Definition: ""
                } as DomainValue);
                return data;
            })
        );
        if (this.form != null && this.applicationState == ApplicationState.Approved) this.form.disable();
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    onDateUpdated(date: Date, field: string): void {
        let ctrl = this.form.get(field);
        if (ctrl != null) ctrl.setValue(date);
    }


    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }
}
